module.exports = __webpack_public_path__ + "media/no_data.c289b233.png";